import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")

  return (_openBlock(), _createBlock(_component_Input, {
    modelValue: _ctx.innerValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.innerValue = $event)),
    label: _ctx.label,
    onBlur: _cache[2] || (_cache[2] = $event => (_ctx.editing = false)),
    onFocus: _cache[3] || (_cache[3] = $event => (_ctx.editing = true)),
    onKeypress: _ctx.checkKeypress
  }, null, 8, ["modelValue", "label", "onKeypress"]))
}